import { render, staticRenderFns } from "./DetailHasilTes.vue?vue&type=template&id=05b72ec3&scoped=true"
import script from "./DetailHasilTes.vue?vue&type=script&lang=js"
export * from "./DetailHasilTes.vue?vue&type=script&lang=js"
import style0 from "./DetailHasilTes.vue?vue&type=style&index=0&id=05b72ec3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b72ec3",
  null
  
)

export default component.exports